import React, { useState } from 'react';
import {
  Alert,
  Button,
  Col,
  Collapse,
  Form,
  Input,
  Layout,
  Modal,
  notification,
  Popconfirm,
  Row,
  Select,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { CustomButton, CustomSelector } from '../../../components';
import { getProjectsActive } from '../../../api/module/project_person';
import {
  activateForm,
  ajaxTableForms as filterForms,
  deactivateForm,
  getCategories,
  updateForm,
} from '../../../api/module/forms';
import {
  DeleteFilled,
  EditFilled,
  PlusSquareFilled,
  SearchOutlined,
  UsergroupDeleteOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import ModalForm from '../../../components/ModalForm';
import MESSAGES from '../../../enums/Messages';
import {
  catchException,
  getLocalStorage,
} from '../../../utils/helpers/helpers';
import AjaxTable from '../../../components/AjaxTable';
import BindUnitsToForms from '../unit/bind_forms';
import { deleteUnitForm, queryUnitFormUnits } from '../../../api/module/unit_form';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function UnitsForms(props) {
  const [form] = Form.useForm();
  const [userId] = useState(getLocalStorage('userId'));
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [openFormModal, setOpenFormModal] = useState(false);
  const [isEditingForm, setIsEditingForm] = useState(false);
  const [selectedProject, setSelectedProject] = useState(undefined);
  const [queryForms, setQueryForms] = useState(undefined);
  const [reloadForms, setReloadForms] = useState(false);
  const [formSelection, setFormSelection] = useState([]);
  const [modalBindUnit, setModalBindUnit] = useState(false);
  const [reloadUnitNested, setReloadUnitNested] = useState(false);

  const breadcrumbItems = [
    {
      text: 'Unidades - Formularios',
    },
  ];

  const columnsForms = [
    {
      title: 'Cod',
      dataIndex: 'codigo',
      key: 'codigo',
    },
    {
      title: 'Proyecto',
      dataIndex: 'proyecto_nombre',
      key: 'proyecto_nombre',
    },
    {
      title: 'Formulario',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Categoría',
      dataIndex: 'categoria_nombre',
      key: 'categoria_nombre',
    },
    {
      title: 'F. Padre',
      dataIndex: 'formulario_padre_nombre',
      key: 'formulario_padre_nombre',
      align: 'center',
      render: (text) => text || '-',
    },
    {
      title: 'Múltiple',
      dataIndex: 'multiple',
      key: 'multiple',
      align: 'center',
      render: (text) => (text ? 'Sí' : 'No'),
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      align: 'center',
      render: (text) => (text ? 'A' : 'I'),
    },
    {
      title: 'Acciones',
      dataIndex: 'accion',
      align: 'center',
      fixed: 'right',
      width: 125,
      render: (_, record) => (
        <Space>
          <Tooltip title='Editar Formulario' placement='top'>
            <EditFilled
              onClick={() => handleEdit(record)}
              disabled={record.usuario !== userId}
              style={{ fontSize: '16px', color: 'green' }}
            />
          </Tooltip>
          { record.estado && (
            <Tooltip title='Desactivar Formulario' placement='top'>
              <Popconfirm
                title="Desactivar Formulario"
                description='Está seguro de desactivar el formulario ?'
                onConfirm={async () => {
                  try {
                    await deactivateForm(record.id);
                    notification.success({
                      message: MESSAGES.SUCCESS_MSG,
                      description: MESSAGES.DESC_SUCCESS_MSG,
                      duration: 2,
                    });
                    setReloadForms({});
                  } catch (error) {
                    catchException(error);
                  }
                }}
                icon={<WarningOutlined style={{ color: 'red' }} />}
              >
                <DeleteFilled
                  style={{ fontSize: '16px', color: 'red' }}
                />
              </Popconfirm>
            </Tooltip>
          )}
          { record.estado === false && (
            <Tooltip title='Reactivar Formulario' placement='top'>
              <Popconfirm
                title="Reactivar Formulario"
                description='Está seguro de reactivar el formulario ?'
                onConfirm={async () => {
                  try {
                    await activateForm(record.id);
                    notification.success({
                      message: MESSAGES.SUCCESS_MSG,
                      description: MESSAGES.DESC_SUCCESS_MSG,
                      duration: 2,
                    });
                    setReloadForms({});
                  } catch (error) {
                    catchException(error);
                  }
                }}
                icon={<WarningOutlined style={{ color: 'orange' }} />}
              >
                <PlusSquareFilled
                  style={{ fontSize: '16px', color: 'orange' }}
                />
              </Popconfirm>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const columnsUnit = [
    {
      title: 'Tipo Estructura',
      dataIndex: 'nombre_estructura',
      key: 'nombre_estructura',
    },
    {
      title: 'Detalle 1',
      dataIndex: 'detalle1',
      key: 'detalle1',
    },
    {
      title: 'Detalle 2',
      dataIndex: 'detalle2',
      key: 'detalle2',
    },
    {
      title: 'Detalle 3',
      dataIndex: 'detalle3',
      key: 'detalle3',
    },
    {
      title: 'Detalle 4',
      dataIndex: 'detalle4',
      key: 'detalle4',
    },
    {
      title: 'Estado',
      dataIndex: 'unidad_activo',
      key: 'unidad_activo',
      render: (text) => (text ? 'A' : 'I'),
    },
    {
      title: 'Acciones',
      dataIndex: 'accion',
      align: 'center',
      fixed: 'right',
      width: 125,
      render: (_, record) => (
        <Space>
          <Tooltip title='Desvincular Unidad' placement='top'>
            <Popconfirm
              title='Desvincular Unidad'
              description='Está seguro de desvincular esta unidad del formulario ?'
              onConfirm={() => unassignUnitForm(record)}
              icon={<WarningOutlined style={{ color: 'red' }} />}>
              <UsergroupDeleteOutlined style={{ fontSize: '18px', color: 'red' }}/>
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleEdit = async (record) => {
    setData(record);
    setIsEditingForm(true);
    setOpenFormModal(true);
  };

  const handleResetModal = () => {
    setData({});
    setIsEditingForm(false);
    setOpenFormModal(false);
  };

  const onFinishModal = async (values, action) => {
    setLoading(true);
    try {
      if (isEditingForm) {
        await updateForm(data.id, values);
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
      }
      if (action !== 'save') {
        handleResetModal();
      } else if (action === 'save') {
        setData(values);
        setIsEditingForm(true);
      }
    } catch (error) {
      catchException(error);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
    initialQuery(selectedProject);
  };

  const initialQuery = (project) => {
    if (selectedProject === undefined) {
      setSelectedProject(project);
    }
    setQueryForms({'filter[proyecto]': project});
  };

  const onFinish = async (values) => {
    if (selectedProject) {
      values.proyecto = selectedProject;
      setQueryForms(
        Object.entries(values).reduce((pv, cv) => {
          pv[`filter[${cv[0]}]`] = cv[1];
          return pv;
        }, {}),
      );
    }
  };

  const onSelectChangeForm = newSelectedRowKeys => {
    setFormSelection(newSelectedRowKeys);
  };

  const rowFormSelected = {
    formSelection,
    onChange: onSelectChangeForm,
  };

  const assignUnits = () => {
    if (formSelection.length > 0) {
      setReloadForms(false);
      setModalBindUnit(true);
    } else {
      notification.warning({
        message: "Formulario Requerido",
        description: "Debe seleccionar al menos un formulario para poder asignar unidades.",
        duration: 3,
      });
    }
  }

  const unassignUnitForm = async (record) => {
    try {
      setReloadUnitNested(false);
      await deleteUnitForm(record.id);
      notification.warning({
        message: "Desvinculación de Unidad",
        description: "La unidad ha sido desvinculada exitosamente.",
        duration: 3,
      });
    } catch (error) {
      console.log(error);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 3,
      });
    } finally {
      setReloadUnitNested(true);
    }
  };

  const expandedRowUnits = (record) => {
    return (
      <AjaxTable
        columns={columnsUnit}
        tableTitle={'Unidades Asignadas'}
        endpoint={queryUnitFormUnits}
        reloadSource={reloadUnitNested}
        scroll={{ x: false }}
        query={`filter[formulario]=${record.id}&filter[proyecto]=${selectedProject}&filter[activo]=true`}
        searchInput
      />
    );
  };

  const responseBindUnit = () => {
    setFormSelection([]);
    setReloadForms(true);
  };

  return (
    <Content>
      <Row>
        <Col span={24}>
          <BreadcrumbContainer items={breadcrumbItems} />
        </Col>
        <Col span={24}>
          <Title className={'text-uppercase'} level={2}>
            Unidades - Formularios
          </Title>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col span={2}>
          <Paragraph>Proyecto:</Paragraph>
        </Col>
        <Col span={17}>
          <CustomSelector
            selectorProps={{
              style: { width: '100%' },
              placeholder:
                'Seleccione el proyecto... ',
            }}
            endpointFetch={async () => {
              return await getProjectsActive();
            }}
            onChange={(value) => initialQuery(value)}
          />
        </Col>
      </Row>
      {selectedProject && (
        <>
        <Row style={{ marginTop: '20px' }}>
          <Col span={24}>
            <Collapse items={[
              {
                key: '1',
                label: <Title level={5}>Búsqueda de formularios</Title>,
                children:
                  <Form
                    form={form}
                    name="forms_search_form"
                    layout="vertical"
                    onFinish={onFinish}
                  >
                    <Row justify="space-between">
                      <Col span={12}>
                        <Form.Item
                          label="Código Formulario:"
                          name="codigo"
                          rules={[
                            { required: false, message: 'Por favor ingrese un código de formulario.' },
                            { min: 3, message: 'El código debe tener al menos 3 caracteres' },
                            { max: 10, message: 'El código no puede tener más de 10 caracteres' }
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label="Estado Formulario:"
                          name="estado"
                          placeholder="Activos / Inactivos / Todos"
                        >
                          <Select>
                            <Select.Option value="1">Activo</Select.Option>
                            <Select.Option value="0">Inactivo</Select.Option>
                            <Select.Option value="2">Todos</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row justify="space-between">
                      <Col span={24}>
                        <Form.Item
                          label="Categoría:"
                          name="categoria"
                          placeholder="Categorías"
                          valuePropName="initialValue"
                        >
                          <CustomSelector
                            selectorProps={{
                              style: { width: '100%' },
                              placeholder: 'Categorías',
                            }}
                            endpointFetch={async () => {
                              return await getCategories();
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item wrapperCol={{ span: 24 }}>
                      <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        htmlType="submit"
                        loading={loading}
                      >Buscar</Button>
                      <Button
                        style={{ marginLeft: '20px' }}
                        danger
                        onClick={() => handleReset()}
                      >Borrar filtros</Button>
                    </Form.Item>
                  </Form>,
              }
            ]}/>
          </Col>
        </Row>
        <Row style={{ marginTop: '20px' }} justify={'center'}>
          <Col>
            <Alert
              message="Seleccione los formularios a los que desea vincular unidades y luego haga click en el boton 'Asignar Unidades'"
              type="info"
              showIcon
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '15px' }} justify={'center'}>
          <Col>
            <CustomButton
              type="default"
              htmlType="button"
              text="Asignar Unidades"
              size="large"
              onClick={() => assignUnits()}
            />
          </Col>
          {modalBindUnit ? <BindUnitsToForms project={selectedProject} parentModalBindUnit={setModalBindUnit} responseBindUnit={responseBindUnit} forms={formSelection} /> : ''}
        </Row>
        <Row style={{ marginTop: '10px' }}>
          <Col span={24}>
            <AjaxTable
              expandedRowRender={{ expandedRowRender: expandedRowUnits }}
              rowSelection={rowFormSelected}
              tableTitle={'Listado de formularios'}
              rowKey={'id'}
              endpoint={filterForms}
              query={queryForms}
              columns={columnsForms}
              searchInput={true}
              reloadSource={reloadForms}
            />
          </Col>
        </Row>
        </>
      )}
      <Modal
        title={'Formulario edición'}
        open={openFormModal}
        onCancel={handleResetModal}
        footer={null}
        width={'80%'}
        destroyOnClose
      >
        <ModalForm
          onFinish={onFinishModal}
          loading={loading}
          isEditing={isEditingForm}
          data={data}
          onCancel={handleResetModal}
        />
      </Modal>
    </Content>
  )
}
